module.exports = function (prefix) {
    return function (request) {
        if (request.url[0] === '/') {
            request.url = prefix + request.url;
        }

        return request;
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/superagent-prefix/index.js
 ** module id = 359
 ** module chunks = 0
 **/